import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgStyleTwoPinOffMap = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	...props,
	children: [
		/* @__PURE__ */ _jsx("title", { children: "style-two-pin-off-map" }),
		/* @__PURE__ */ _jsx("path", {
			d: "M10.751,14.179a3.753,3.753,0,0,1-2.912-2.861",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M11.5,6.754a3.75,3.75,0,0,1,3.75,3.75",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M15.25,21.133a19.884,19.884,0,0,1-3.111,1.841,1.5,1.5,0,0,1-1.277,0C8.7,21.956,1.75,18.1,1.75,10.5A9.717,9.717,0,0,1,2.5,6.753",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M6.946,1.88A9.754,9.754,0,0,1,21.25,10.5a11.565,11.565,0,0,1-.886,4.484",
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		}),
		/* @__PURE__ */ _jsx("line", {
			x1: 1,
			y1: .754,
			x2: 22.75,
			y2: 22.504,
			fill: "none",
			stroke: "currentColor",
			strokeLinecap: "round",
			strokeLinejoin: "round",
			strokeWidth: "1.5px"
		})
	]
});
export { SvgStyleTwoPinOffMap as ReactComponent };
